import { getBranding } from 'utils/branding';

/**
 * 케어센스 에러 메시지 반환
 * Division에 따라 "애니핏 플러스" 또는 "애니핏 프로" 표시
 */
export function getCaresenseErrorMessage() {
  const branding = getBranding();
  return `${branding.name}에서 다시 연동을 시도해 주세요.`;
}

/**
 * 케어센스 전용 에러 페이지로 리다이렉트
 */
export function navigateToCaresenseError(navigate) {
  navigate('/caresense/error');
}
